import { InitialLoadAction } from "./initial-load-action"
import { Injectable } from "@angular/core";
import { LoadingService } from "./loading-service";
import { UiMessageService } from "../ui-message-broker/ui-message-broker.service";


@Injectable({
    providedIn: 'root'
  })
export class InitUIMessageBrokerAction extends InitialLoadAction<boolean> {

    constructor(loadingService : LoadingService, 
        private uiMessageBrokerService : UiMessageService) {
        super('UIMessageBroker', loadingService);
    }

    override onLoad(): Promise<boolean> {
        return new Promise<boolean>(
            (resolve, reject) => {
                this.uiMessageBrokerService.connect();
                resolve(true);
            }
        );

    }
}